
import { mapActions } from 'vuex'
import MissionStatement from '@/components/ui/MissionStatement'
import Founder from '@/components/ui/Founder'

export default {

  components: {
    MissionStatement,
    Founder
  },
  nuxtI18n: {
    paths: {
      de: '/ueber-uns',
      en: '/about-us',
      se: '/om-oss',
      nl: '/over-ons',
      da: '/om-os',
      pl: '/o-nas',
      es: '/sobre-nosotros',
      cs: '/o-nas'

    }
  },
  data () {
    return {
      title: this.$t('about.title')
    }
  },
  head () {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('about.description')
        }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.collect({
        action: 'view'
      })
    })
  },
  methods: {
    ...mapActions('useractionlog', ['collect'])
  }
}
